import type {Recipe} from './types';

export const crostataMarmellata: Recipe = {
    id: 2,
    key: "crostataMarmellata",
    pictures: [
        {index: 0, url: "https://blog.giallozafferano.it/inventaricette/wp-content/uploads/2020/07/crostata-confettura-albicocche-vid-720x460.jpg"},
    ],
    i18n: {
        IT: {
            title: "Crostata di Marmellata",
            servings: "8 porzioni",
            ingredients: [
                "330 gr di farina",
                "150 gr di burro",
                "130 gr di zucchero",
                "1 uovo",
                "2 tuorli",
                "7 gr di zucchero vanigliato",
                "2 gr di sale",
                "1 gr di lievito per dolci",
                "330 gr di marmellata",
            ],
            steps: [
                "Ammorbidire il burro rimescolando con zucchero e sale fino ad amalgamare il tutto",
                "Includere l'uovo e i tuorli",
                "Frullare il tutto fino ad avere una pasta omogenea",
                "Aggiungere farina, lievito e rimescolare fino a comporre una palla che si stacca facilmente dalle mani",
                "Mettere in frigo per 1 ora",
                "Stendere la palla su un piano infarinato con un mattarello infarinato. Creare un cerchio di circa più di 3 mm di spessore e diametro ampiamente più largo dello stampo",
                "Imburrare lo stampo per bene fondo e lati",
                "Avvolgere l'impasto attorno al mattarello e stenderlo sulla teglia. Far aderire bene la pasta ai bordi utilizzando le nocche delle mani onde evitare di romperla",
                "Schiacciare i bordi in modo da rimuovere tutta la pasta in eccesso che straripante dallo stampo",
                "Bucherellare il fondo dello stampo con una forchetta",
                "Mettere la marmellata in una ciotola e mescolare velocemente in modo da schiacciare tutti i pezzi di frutta e renderla omogenea",
                "Versare la marmellata nello stampo e stenderla con una spatola",
                "Stendere la restante pasta creando un rettangolo bello largo",
                "Tagliare a strisce",
                "Adagiare le strisce a rete sulla marmellata facendo aderire i capi con la pasta ai bordi",
                "Togliere i pezzi in eccesso e impastare in modo da creare altre strisce",
                "Stendere prima da un lato e poi dall'altro",
                "Mettere in forno 20 minuti al centro a 180 gradi",
                "Spostare nella parte inferiore del forno e cuocere a 170 gradi per altri 10 minuti",
            ],
            notes: "La pasta ottimale si presenta molto dura, con una consistenza simile alla plastilina.\nPer semplificare la lavorazione rimettere in frigo le parti di impasto che non vengono immediatamente utilizzate.\nManeggiare le striscie di pasta quando sono ancora dure è molto più facile",
        },
        EN: {
            title: "Jam Tart",
            servings: "8 servings",
            ingredients: [
                "330 g flour",
                "150 g butter",
                "130 g sugar",
                "1 egg",
                "2 yolks",
                "7 g vanilla sugar",
                "2 g salt",
                "1 g baking powder",
                "330 g jam",
            ],
            steps: [
                "Soften the butter by mixing with sugar and salt until well combined.",
                "Include the egg and yolks.",
                "Blend everything until you have a smooth dough.",
                "Add flour, baking powder and mix until you form a ball that easily detaches from your hands.",
                "Refrigerate for 1 hour.",
                "Roll out the ball on a floured surface with a floured rolling pin. Create a circle about more than 3 mm thick and with a diameter significantly larger than the mold.",
                "Butter the mold well on the bottom and sides.",
                "Wrap the dough around the rolling pin and spread it on the pan. Press the dough well against the edges using your knuckles to avoid breaking it.",
                "Press the edges to remove all excess dough overflowing from the mold.",
                "Prick the bottom of the mold with a fork.",
                "Put the jam in a bowl and mix quickly to crush all the pieces of fruit and make it homogeneous.",
                "Pour the jam into the mold and spread it with a spatula.",
                "Roll out the remaining dough creating a nice wide rectangle.",
                "Cut into strips.",
                "Place the strips in a lattice pattern over the jam, making the ends adhere to the dough at the edges.",
                "Remove the excess pieces and knead to create more strips.",
                "Lay first one way and then the other.",
                "Bake for 20 minutes in the center at 180 degrees.",
                "Move to the lower part of the oven and bake at 170 degrees for another 10 minutes.",
            ],
            notes: "The optimal dough is very hard, with a consistency similar to plasticine.\nTo simplify the process, refrigerate the dough parts that are not immediately used.\nHandling the dough strips while they are still hard is much easier.",
        },
        PL: {
            title: "Tarta z Dżemem",
            servings: "8 porcji",
            ingredients: [
                "330 g mąki",
                "150 g masła",
                "130 g cukru",
                "1 jajko",
                "2 żółtka",
                "7 g cukru waniliowego",
                "2 g soli",
                "1 g proszku do pieczenia",
                "330 g dżemu",
            ],
            steps: [
                "Zmiękczyć masło, mieszając je z cukrem i solą, aż wszystko się połączy.",
                "Dodać jajko i żółtka.",
                "Zmiksować wszystko, aż uzyskasz gładkie ciasto.",
                "Dodać mąkę, proszek do pieczenia i mieszać, aż utworzy się kula, która łatwo odkleja się od rąk.",
                "Schłodzić w lodówce przez 1 godzinę.",
                "Rozwałkować kulę na oprószonej mąką powierzchni, używając oprószonego mąką wałka. Utworzyć koło o grubości ponad 3 mm i średnicy znacznie większej niż forma.",
                "Dobrze wysmarować formę masłem na dnie i bokach.",
                "Zawinąć ciasto wokół wałka i rozprowadzić na formie. Dobrze docisnąć ciasto do brzegów, używając kostek dłoni, aby nie pękło.",
                "Docisnąć brzegi, aby usunąć nadmiar ciasta wystającego poza formę.",
                "Nakłuć dno formy widelcem.",
                "Włożyć dżem do miski i szybko wymieszać, aby rozgnieść wszystkie kawałki owoców i uzyskać jednolitą konsystencję.",
                "Wlać dżem do formy i rozprowadzić go szpatułką.",
                "Rozwałkować pozostałe ciasto, tworząc szeroki prostokąt.",
                "Pokroić na paski.",
                "Ułożyć paski w kratkę na dżemie, dociskając końce do ciasta na brzegach.",
                "Usunąć nadmiar ciasta i zagnieść, aby stworzyć więcej pasków.",
                "Układać najpierw w jedną stronę, a potem w drugą.",
                "Piec przez 20 minut w środkowej części piekarnika w temperaturze 180 stopni.",
                "Przenieść do dolnej części piekarnika i piec w temperaturze 170 stopni przez kolejne 10 minut.",
            ],
            notes: "Optymalne ciasto jest bardzo twarde, o konsystencji podobnej do plasteliny.\nAby uprościć pracę, schłodzić części ciasta, które nie są od razu używane.\nŁatwiej jest obsługiwać paski ciasta, gdy są jeszcze twarde.",
        },
    },
};
